// src/components/FilterModal.js

import React from 'react';
import { Modal, Box, Typography, TextField, Radio, RadioGroup, FormControlLabel, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

const StyledModal = styled(Modal)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const ModalContent = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    borderRadius: theme.shape.borderRadius,
    width: '300px',
}));

const FilterModal = ({
    open,
    onClose,
    title,
    searchTerm,
    setSearchTerm,
    tempSearchTerm,
    setTempSearchTerm,
    sortBy,
    setSortBy,
    tempSortBy,
    setTempSortBy,
    handleApplyFilters,
    handleCancelFilters,
    searchLabel,
    sortLabel,
}) => {
    return (
        <StyledModal open={open} onClose={onClose}>
            <ModalContent>
                <Typography variant="h6" component="h2" gutterBottom>
                    {title}
                </Typography>
                <TextField
                    fullWidth
                    label={searchLabel}
                    value={tempSearchTerm}
                    onChange={(e) => setTempSearchTerm(e.target.value)}
                    sx={{ mb: 2 }}
                />
                <Typography variant="subtitle1" gutterBottom>
                    {sortLabel}
                </Typography>
                <RadioGroup
                    value={tempSortBy}
                    onChange={(e) => setTempSortBy(e.target.value)}
                >
                    <FormControlLabel value="lastActivity" control={<Radio />} label="Last activity" />
                    <FormControlLabel value="rentalPeriodStart" control={<Radio />} label="Rental period start" />
                    <FormControlLabel value="rentalPeriodEnd" control={<Radio />} label="Rental period end" />
                </RadioGroup>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleApplyFilters}
                    sx={{ mt: 2 }}
                >
                    Apply
                </Button>
                <Button
                    fullWidth
                    variant="outlined"
                    onClick={handleCancelFilters}
                    sx={{ mt: 1 }}
                >
                    Cancel
                </Button>
            </ModalContent>
        </StyledModal>
    );
};

FilterModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    searchTerm: PropTypes.string.isRequired,
    setSearchTerm: PropTypes.func.isRequired,
    tempSearchTerm: PropTypes.string.isRequired,
    setTempSearchTerm: PropTypes.func.isRequired,
    sortBy: PropTypes.string.isRequired,
    setSortBy: PropTypes.func.isRequired,
    tempSortBy: PropTypes.string.isRequired,
    setTempSortBy: PropTypes.func.isRequired,
    handleApplyFilters: PropTypes.func.isRequired,
    handleCancelFilters: PropTypes.func.isRequired,
    searchLabel: PropTypes.string,
    sortLabel: PropTypes.string,
};

FilterModal.defaultProps = {
    searchLabel: 'Search by item or user name',
    sortLabel: 'Sort by',
};

export default FilterModal;
